import { TInsuredNew, TChildCount, IFinalSelection } from 'Constants/groupTypes'
import {
  MemberSelectionInitials,
  childCountInitials,
  FinalSelectionInitials,
} from '../BobSellJourney/initials'
import { createSlice } from '@reduxjs/toolkit'
import { IInsuredDetailsHealth, INomineeDetails, IPlanHealthDetails } from 'types'
import { IPlanDetails } from 'Models/ResponseModels'

export interface IStateGroupHealth {
  lead: {
    memberSelection: TInsuredNew[]
    childCount: TChildCount
    finalSelection: IFinalSelection[]
  }
  insuredDetails: IInsuredDetailsHealth
  nomineeDetails: INomineeDetails
  quotationDetails: {
    [key: string]: any
  }
  quotationHealthDetails: {
    [key: string]: any
  }
  planHealthDetails?: any
  medicalQuestions: any
  medicalQuestionList: any
  isInteractedMedQues: string[]

  // consent_status: any
}

export const initialState: IStateGroupHealth = {
  lead: {
    memberSelection: MemberSelectionInitials,
    childCount: childCountInitials,
    finalSelection: FinalSelectionInitials,
  },
  insuredDetails: {},
  nomineeDetails: {
    nomineeSalutation: '',
    nomineeFirstName: '',
    nomineeLastName: '',
    dob: '',
    nomineeGender: '',
    relationship: '',
    nomineeEmail: '',
    nomineePhoneNumber: '',
  },
  quotationDetails: {},
  quotationHealthDetails: {},
  //  Plan Details (common and same for all members)
  planHealthDetails: { sum_insured: '', policy_term: '' },
  medicalQuestions: null,
  medicalQuestionList: null,
  isInteractedMedQues: [],
  // consent_status: 'SUBMIT' | 'REJECT',
}

const groupHealthSlice = createSlice({
  name: 'groupHealthSlice',
  initialState: initialState,
  reducers: {
    updateLeadDetails: (state, action) => {
      state.lead = action.payload
    },
    updateMemberSelection: (state, action) => {
      state.lead.memberSelection = action.payload
    },
    updateQuoteID: (state, action) => {
      state.insuredDetails.quote_id = action.payload
    },
    setConsentID: (state, action) => {
      state.insuredDetails.consent_id = action.payload
    },
    setConsentResponse: (state, action) => {
      state.insuredDetails.consent_response = action.payload
    },
    updatePlanHealthDetails: (state, action) => {
      state.planHealthDetails = action.payload
    },
    updatePaymentResponseGPA: (state, action) => {
      state.insuredDetails.payment_response = {
        ...state.insuredDetails.payment_response,
        ...action.payload,
      }
    },
    updateInsuredDetails: (state, action) => {
      console.log(Object.isFrozen(action.payload.data), 'Slice')
      state.insuredDetails = action.payload
    },
    resetInsuredDetails: (state) => {
      state = { ...state, insuredDetails: {} }
      return state
    },
    updateQuotationDetails: (state, action) => {
      state.quotationDetails = action.payload
    },
    updateQuotationHealthDetails: (state, action) => {
      state.quotationHealthDetails = action.payload
    },

    updateNomineeDetails: (state, action) => {
      state.nomineeDetails = action.payload
    },
    updateGroupHealthData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    updateMedicalQuestionsGroup: (state, action) => {
      state.medicalQuestions = action.payload
    },
    setMedicalQuestionList: (state, action) => {
      state.medicalQuestionList = action.payload
    },
    updateIsInteractedMedQues: (state, action) => {
      state.isInteractedMedQues = Array.isArray(action.payload) ? action.payload : []
    },
    resetGroupHealthData: (state) => {
      state.lead = { ...initialState.lead }
      state.insuredDetails = { ...initialState.insuredDetails }
      state.medicalQuestions = { ...initialState.medicalQuestions }
      state.medicalQuestionList = { ...initialState.medicalQuestionList }
      state.nomineeDetails = { ...initialState.nomineeDetails }
      state.planHealthDetails = { ...initialState.planHealthDetails }
      state.quotationDetails = { ...initialState.quotationDetails }
      state.quotationHealthDetails = { ...initialState.quotationHealthDetails }
    },
  },
})

const { reducer } = groupHealthSlice
const {
  updateLeadDetails,
  setConsentResponse,
  updateMemberSelection,
  updateInsuredDetails,
  resetInsuredDetails,
  updatePaymentResponseGPA,
  updateQuotationDetails,
  updateQuotationHealthDetails,
  resetGroupHealthData,
  updateNomineeDetails,
  updateQuoteID,
  setConsentID,
  updateGroupHealthData,
  updatePlanHealthDetails,
  updateMedicalQuestionsGroup,
  updateIsInteractedMedQues,
  setMedicalQuestionList,
} = groupHealthSlice.actions

export {
  reducer as groupHealthReducer,
  updateLeadDetails,
  updateMemberSelection,
  resetInsuredDetails,
  updatePaymentResponseGPA,
  updateQuotationDetails,
  updateQuotationHealthDetails,
  resetGroupHealthData,
  updateNomineeDetails,
  setConsentResponse,
  updateInsuredDetails,
  setConsentID,
  updateQuoteID,
  updateGroupHealthData,
  updatePlanHealthDetails,
  setMedicalQuestionList,
  updateMedicalQuestionsGroup,
  updateIsInteractedMedQues,
}
